export const SAMPLE_TYPES_ACTIONS = {
    FIND: 'FIND_SAMPLE_TYPES',
    GET: 'GET_SAMPLE_TYPES',
    GET_LIST: 'GET_SAMPLE_TYPES_LIST',


    GET_SAMPLE_TYPE_LIST_BY_PATERNITY_STUDY_TYPE: 'GET_SAMPLE_TYPE_LIST_BY_PATERNITY_STUDY_TYPE',
    GET_SAMPLE_TYPE_LIST_BY_CLINICAL_ANALYSIS_TYPE: 'GET_SAMPLE_TYPE_LIST_BY_CLINICAL_ANALYSIS_TYPE',


    CHANGE_STATUS: 'CHANGE_STATUS_SAMPLE_TYPES',
    SUCCESS: 'SUCCESS_SAMPLE_TYPES',
    ERROR: 'ERROR_SAMPLE_TYPES',
    CLEAN: 'CLEAN_SAMPLE_TYPES',
}